import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ValdostaProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Valdosta"
      headingExtra="GA"
      introText="Valdosta travelers — Moody AFB personnel, VSU students, and South Georgia families near the Florida line — have several passport options. Here is how they compare, and why most Lowndes County residents choose a registered State Department courier rather than driving 230 miles to Atlanta for an emergency passport agency appointment."
      options={options}
      emergencyDescription="Georgia has only 1 passport agency (Atlanta, ~230 miles via I-75, 3.5+ hours). South Georgia has zero agencies — Valdosta sits in a multi-state dead zone with no agency in North Florida either (the closest Florida agency is Miami, 430+ miles away). I-75 construction between Macon and Atlanta adds unpredictable delays year-round, and the single Atlanta agency serves all of Georgia plus border-region residents from AL, TN, and SC — making appointments fiercely competitive."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing."
    />
  );
}